import createBaseService from "@/api/base-service.ts";
import type { Client, ClientOption } from "../../types/client";

const clientService = {
	...createBaseService<Client>("/clients"),

	async search(searchTerm = ""): Promise<{ data: ClientOption[] }> {
		const response = await fetch(`/api/clients/search?search=${encodeURIComponent(searchTerm)}`);
		return response.json();
	},
};

export default clientService;
